import * as React from "react";
import { Fun, mk_widget, option, Options, Widget } from "../widget";

export interface ImageOptions extends Options {
  alt?:string,
  src?:string
}

/** @deprecated Use [[wrapHTML]] instead. */
export const image = function<o>(options:ImageOptions) : Fun<Widget<o>,Widget<o>> {
  return (inner_widget:Widget<o>) : Widget<o> => mk_widget({
    run:(on_done:(output:o) => void) =>
      <>
        <img  id={option("id", options)}
              role={option("role", options)}
              alt={option("alt", options)}
              src={option("src", options)}
              className={options ? options.className : undefined}
              style={options ? options.style : undefined}
              key={options ? options.key : undefined} />
        { inner_widget.run(on_done) }
      </>
  })
}



// WEBPACK FOOTER //
// ./node_modules/widgets-for-react/src/primitives/image.tsx